import store from '../../store';

export default async (to, from, next) => {
    if (process.env.VUE_ENV === 'development')
        console.log(to.name.split('-')[1]);
    if (store.getters['authenticated']) {
        if (store.getters['authenticated'] && store.getters['permissions'].includes('viewAny ' + to.name.split('-')[1])) {
            next();
        } else {
            await store.dispatch('setErrorModal', true);
            await store.dispatch('setErrorMessage', `You don\'t have permission to view ${to.name.split('-')[1]}`);
            next({path: from.path});
        }
    } else {
        next({name: 'login-page'});
    }

}